import * as React from 'react';
import { memo } from 'react';
const SvgTypeStraight = (props) => (
  <svg width={164} height={128} viewBox="0 0 164 128" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.222 136.654L28.244 -10.8084L29.3102 136.655L27.222 136.654ZM43.5635 -10.7377L42.1919 136.724L44.977 136.723L43.5635 -10.7377ZM56.8121 136.671L58.8782 -10.79L60.991 136.672L56.8121 136.671ZM70.7353 136.68L74.1952 -10.7808L77.7019 136.682L70.7353 136.68ZM104.834 -10.7624L102.763 136.699L106.945 136.702L104.834 -10.7624ZM86.0549 136.687L89.5172 -10.7716L93.019 136.691L86.0549 136.687ZM135.469 -10.7439L134.447 136.718L136.535 136.719L135.469 -10.7439ZM118.78 136.709L120.151 -10.7532L121.567 136.71L118.78 136.709Z"
      fill="#51574E"
    />
  </svg>
);
const Memo = memo(SvgTypeStraight);
export default Memo;
